import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal, Toast, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTrash, FaPlus, FaDownload, FaEdit } from 'react-icons/fa';
import { getActiveTenders, deleteTender, updateTender } from '../../services/tenderService';
import moment from 'moment';
import 'moment/locale/tr';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import mammoth from 'mammoth';
import './Tenders.scss';

const TenderList = () => {
  const statusOptions = [
    { id: '8AF7F84A-B3CC-4208-A030-32E3E9891C28', label: 'Sonuçlandı' },
    { id: '8F9F7E16-17E1-43B4-988B-76B6395E03ED', label: 'Sonuçlanmadı' },
    { id: '12D309D8-1F87-4A64-A3D7-C8DEDAB27978', label: 'İptal Edildi' }
  ];
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTender, setSelectedTender] = useState(null);
  const [editTender, setEditTender] = useState({
    guid: '',
    header: '',
    detail: '',
    department: '',
    date: '',
    deadline: '',
    kikNo: '',
    address: '',
    phone: '',
    email: '',
    subject: '',
    placeOfDelivery: '',
    dateOfDelivery: '',
    tendarOrganizationAddress: '',
    detailDescription: '',
    statusId: '',
    file: null,
    fileBase64: '',
    fileUrl: ''
  });

  useEffect(() => {
    fetchTenders();
  }, []);

  const fetchTenders = async () => {
    try {
      const response = await getActiveTenders();
      console.log('API Response:', response);
      
      if (response?.items) {
        setTenders(response.items);
        setError(null);
      } else {
        setError('İhaleler yüklenirken bir hata oluştu.');
        setTenders([]);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setError('İhaleler yüklenirken bir hata oluştu.');
      setTenders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedTender) return;

    try {
      const response = await deleteTender(selectedTender.guid);
      if (response.isSuccess) {
        setTenders(tenders.filter(tender => tender.guid !== selectedTender.guid));
        setToastMessage('İhale başarıyla silindi!');
        setToastVariant('success');
        setShowToast(true);
      } else {
        setToastMessage('İhale silinirken bir hata oluştu.');
        setToastVariant('danger');
        setShowToast(true);
      }
    } catch (error) {
      console.error('Delete error:', error);
      setToastMessage('İhale silinirken bir hata oluştu.');
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setShowDeleteModal(false);
      setSelectedTender(null);
    }
  };

  const confirmDelete = (tender) => {
    setSelectedTender(tender);
    setShowDeleteModal(true);
  };

  const handleEdit = (tender) => {
    // Önemli: API'den gelen format tüm harfler büyük olabilir, bu yüzden case-insensitive karşılaştırma yapalım
    // Önce StatusID kontrol edilir, yoksa statusId
    let tenderStatusId = tender.StatusID || tender.statusId;
    
    // Eğer statusId yoksa veya geçersizse, varsayılan değeri kullan (Sonuçlanmadı)
    const defaultStatusId = '8F9F7E16-17E1-43B4-988B-76B6395E03ED';
    
    // TenderStatusId null/undefined ise veya geçersiz bir format ise varsayılan kullan
    if (!tenderStatusId || typeof tenderStatusId !== 'string') {
      console.log('Geçersiz statusId, varsayılan kullanılıyor');
      tenderStatusId = defaultStatusId;
    }
    
    console.log('HandleEdit - Alınan tender:', {
      guid: tender.guid,
      statusId: tender.statusId,
      StatusID: tender.StatusID,
      kullanılacakStatusId: tenderStatusId
    });
    
    // StatusOptions içinde eşleşen ID'yi bul (case insensitive)
    const bulunanStatus = statusOptions.find(
      option => option.id.toLowerCase() === tenderStatusId.toLowerCase()
    );
    
    let statusId = tenderStatusId;
    let statusLabel = 'Sonuçlanmadı'; // Varsayılan değer
    
    if (bulunanStatus) {
      // Eşleşen durum bulundu, doğru vaka kullanımını kullan
      statusId = bulunanStatus.id; // Doğru formatta ID
      statusLabel = bulunanStatus.label;
      console.log('Bulunan durum:', statusLabel, 'ID:', statusId);
    } else {
      // Durum bulunamadı, varsayılan kullan
      statusId = defaultStatusId;
      console.log('Durum bulunamadı, varsayılan kullanılıyor. Aranan ID:', tenderStatusId);
    }
    
    setSelectedTender(tender);
    
    // Düzgün belirlenen değerleri editTender için kullan
    // Adres ve email için varsayılan değerleri kullan (eğer mevcut değer yoksa veya boşsa)
    const defaultAddress = 'İSKENDERUN BELEDİYESİ BRİFİNG SALONU KAT:3 ( YENİŞEHİR MAHALLESİ M. FEVZİ ÇAKMAK CAD. NO:11 İSKENDERUN / HATAY )';
    const defaultEmail = 'ihale@iskenderun.bel.tr';
    
    const updatedEditTender = {
      guid: tender.guid,
      header: tender.header,
      detail: tender.detail,
      department: tender.department,
      date: tender.date,
      deadline: tender.deadline,
      kikNo: tender.kikNo,
      address: tender.address || defaultAddress,
      phone: tender.phone,
      email: tender.email || defaultEmail,
      subject: tender.subject,
      placeOfDelivery: tender.placeOfDelivery,
      dateOfDelivery: tender.dateOfDelivery,
      tendarOrganizationAddress: tender.tendarOrganizationAddress,
      detailDescription: tender.detailDescription,
      statusId: statusId, // Belirlenen statusId'yi kullan (doğru format)
      statusLabel: statusLabel, // Durum etiketi için
      file: null,
      fileBase64: '',
      fileUrl: tender.fileUrl || ''
    };
    
    // Form için kullanılacak değerler
    setEditTender(updatedEditTender);
    
    console.log('EditTender state ayarlandı:', {
      statusId: tenderStatusId,
      statusLabel: statusLabel
    });
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      
      // Mevcut ihale verilerini kullanarak güncelleme verilerini oluştur
      const updateData = { ...editTender };
      
      // StatusId kontrolü ve debug log
      console.log('handleEditSubmit statusId:', {
        statusId: updateData.statusId,
        statusLabel: updateData.statusLabel,
        type: typeof updateData.statusId
      });
      
      // StatusId'nin doğru şekilde gönderildiğinden emin ol
      if (!updateData.statusId) {
        console.error('StatusId eksik veya geçersiz!');
        // Varsayılan değeri kullanma
        updateData.statusId = '8F9F7E16-17E1-43B4-988B-76B6395E03ED'; // Sonuçlanmadı
      }
      
      // Eğer yeni bir dosya seçilmemişse, mevcut dosyayı kullan
      if (!updateData.file && selectedTender?.fileUrl) {
        // Mevcut dosya bilgisini koru
        updateData.existingFileUrl = selectedTender.fileUrl;
        console.log('Mevcut dosya korunuyor:', selectedTender.fileUrl);
      } else if (!updateData.file && !selectedTender?.fileUrl) {
        // Eğer dosya seçilmemiş ve mevcut dosya da yoksa, boş gönder
        updateData.file = null;
        updateData.fileBase64 = '';
        updateData.existingFileUrl = '';
        console.log('Dosya seçilmedi ve mevcut dosya yok, boş gönderiliyor');
      }
      
      console.log('Güncelleme için gönderilen veri:', {
        ...updateData,
        file: updateData.file ? 'Yeni dosya seçildi' : 'Dosya seçilmedi',
        existingFileUrl: updateData.existingFileUrl || 'Yok'
      });
      
      const response = await updateTender(updateData);
      
      if (response?.isSuccess || response?.data?.isSuccess || response === true || response?.data === true) {
        setToastMessage('İhale başarıyla güncellendi!');
        setToastVariant('success');
        setShowToast(true);
        await fetchTenders();
        setShowEditModal(false);
      } else {
        const errorMessage = response?.data?.resultMessage || 'İhale güncellenirken bir hata oluştu.';
        setToastMessage(errorMessage);
        setToastVariant('danger');
        setShowToast(true);
      }
    } catch (error) {
      console.error('Error updating tender:', error);
      const errorMessage = error.response?.data?.message || 'İhale güncellenirken bir hata oluştu.';
      setToastMessage(errorMessage);
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // StatusId değişikliklerini özel olarak izle
    if (name === 'statusId') {
      console.log('StatusId değişti:', {
        eski: editTender.statusId,
        yeni: value,
        tip: typeof value,
        hedef: e.target,
        seçilen_index: e.target.selectedIndex,
        seçilen_option: e.target.options[e.target.selectedIndex],
        seçilen_option_text: e.target.options[e.target.selectedIndex]?.text,
        seçilen_option_value: e.target.options[e.target.selectedIndex]?.value
      });
      
      // Seçilen option'un value değerini doğrudan al
      const seçilenDeğer = e.target.options[e.target.selectedIndex]?.value;
      
      // Yeni değeri güncelle
      setEditTender(prev => ({
        ...prev,
        [name]: seçilenDeğer
      }));
      
      // Fonksiyonu burada sonlandır
      return;
    }
    
    // Diğer alanlar için normal güncelleme
    setEditTender(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Validate file type
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        setToastMessage('Sadece PDF ve Word dosyaları kabul edilmektedir');
        setToastVariant('danger');
        setShowToast(true);
        e.target.value = ''; // Clear the file input
        return;
      }
      
      // Eğer .docx dosyası ise içeriğini Detay alanına aktar
      // PDF dosyaları için otomatik doldurma yapılmaz, sadece dosya yüklenir
      const isDocx = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    file.name.toLowerCase().endsWith('.docx');
      
      if (isDocx) {
        try {
          setLoading(true);
          const arrayBuffer = await file.arrayBuffer();
          const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
          
          // Detay alanına HTML içeriğini ekle
          setEditTender(prev => ({
            ...prev,
            file: file,
            detail: result.value // HTML içeriği
          }));
          
          setToastMessage('Word dosyası içeriği Detay alanına aktarıldı!');
          setToastVariant('success');
          setShowToast(true);
        } catch (error) {
          console.error('Word dosyası okuma hatası:', error);
          setToastMessage('Word dosyası okunurken bir hata oluştu. Dosya yine de yüklenecek.');
          setToastVariant('warning');
          setShowToast(true);
          
          setEditTender(prev => ({
            ...prev,
            file: file
          }));
        } finally {
          setLoading(false);
        }
      } else {
        setEditTender(prev => ({
          ...prev,
          file: file
        }));
      }
    }
  };

  if (loading) {
    return (
      <Container>
        <div className="text-center mt-5">Yükleniyor...</div>
      </Container>
    );
  }

  return (
    <Container fluid>
      <div
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 9999
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={1500}
          autohide
          bg={toastVariant}
        >
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>İhaleler</h2>
        <Link to="/tenders/add">
          <Button variant="primary">
            <FaPlus className="me-2" />
            Yeni İhale Ekle
          </Button>
        </Link>
      </div>

      {error ? (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      ) : tenders.length === 0 ? (
        <div className="text-center mt-5">
          <p>Henüz ihale bulunmuyor.</p>
        </div>
      ) : (
        <div className="tender-list-container">
          <Row>
            {tenders.map((tender) => (
              <Col key={tender.guid} lg={4} md={6} className="mb-4" style={{ minWidth: 0 }}>
              <Card className="h-100 tender-card">
                <Card.Body>
                  <Card.Title>
                    {tender.header}
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                      <div
                        style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: tender.statusColorCode || '#ccc',
                          marginRight: '8px'
                        }}
                      />
                      <span style={{ fontSize: '14px', color: '#666' }}>
                        {tender.statusName}
                      </span>
                    </div>
                  </Card.Title>
                  <div className="tender-details">
                    <p><strong>Birim:</strong> {tender.department}</p>
                    <p><strong>Tarih:</strong> {moment(tender.date).format('DD.MM.YYYY')}</p>
                    {tender.deadline && tender.deadline !== '0001-01-01T00:00:00' && (
                      <p><strong>Son Tarih:</strong> {moment(tender.deadline).format('DD.MM.YYYY')}</p>
                    )}
                    {tender.detail && (
                      <div 
                        className="tender-detail"
                        dangerouslySetInnerHTML={{ __html: tender.detail }}
                      />
                    )}
                  </div>
                </Card.Body>
                <Card.Footer className="bg-white">
                  <div className="d-flex justify-content-between">
                    <div>
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={() => confirmDelete(tender)}
                        className="me-2"
                      >
                        <FaTrash className="me-1" /> Sil
                      </Button>
                      <Button 
                        variant="outline-secondary" 
                        size="sm"
                        onClick={() => handleEdit(tender)}
                      >
                        <FaEdit className="me-1" /> Düzenle
                      </Button>
                    </div>
                    {tender.fileUrl && (
                      <Button 
                        variant="outline-primary" 
                        size="sm"
                        href={tender.fileUrl}
                        target="_blank"
                      >
                        <FaDownload className="me-1" /> İndir
                      </Button>
                    )}
                  </div>
                </Card.Footer>
              </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>İhale Silme</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu ihaleyi silmek istediğinizden emin misiniz?
          <br />
          <strong>{selectedTender?.header}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Sil
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>İhale Düzenle</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEditSubmit}>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Başlık</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="header" 
                    value={editTender.header} 
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Birim</Form.Label>
                  <Form.Control 
                    type="text" 
                    name="department" 
                    value={editTender.department} 
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>İhale Tarihi</Form.Label>
                  <Form.Control 
                    type="date" 
                    name="date" 
                    value={editTender.date ? new Date(editTender.date).toISOString().split('T')[0] : ''} 
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Adres</Form.Label>
                  <Form.Control 
                    as="textarea"
                    rows={2}
                    name="address" 
                    value={editTender.address} 
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control 
                    type="email" 
                    name="email" 
                    value={editTender.email} 
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>İhale Durumu</Form.Label>
              <Form.Select
                name="statusId"
                value={editTender.statusId || ''}
                onChange={(e) => {
                  const selectedIndex = e.target.selectedIndex;
                  const selectedOption = statusOptions[selectedIndex];
                  
                  if (selectedOption) {
                    console.log('Seçilen durum:', {
                      label: selectedOption.label,
                      id: selectedOption.id
                    });
                    
                    setEditTender(prev => ({
                      ...prev,
                      statusId: selectedOption.id,
                      statusLabel: selectedOption.label
                    }));
                  }
                }}
                required
              >
                {statusOptions.map(option => (
                  <option 
                    key={option.id} 
                    value={option.id}
                  >
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Detay</Form.Label>
                  <ReactQuill
                    theme="snow"
                    value={editTender.detail || ''}
                    onChange={(value) => {
                      setEditTender(prev => ({
                        ...prev,
                        detail: value
                      }));
                    }}
                    modules={{
                      toolbar: [
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'script': 'sub'}, { 'script': 'super' }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        ['link', 'image', 'video'],
                        ['code-block'],
                        ['clean']
                      ]
                    }}
                    formats={[
                      'header', 'font', 'size',
                      'bold', 'italic', 'underline', 'strike', 'blockquote',
                      'color', 'background',
                      'script',
                      'list', 'bullet', 'indent',
                      'align',
                      'link', 'image', 'video',
                      'code-block'
                    ]}
                    style={{ height: '400px', marginBottom: '50px' }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Dosya {editTender.fileUrl && '(Mevcut dosya var)'}</Form.Label>
              <Form.Control 
                type="file" 
                onChange={handleFileChange}
              />
              {editTender.fileUrl && (
                <div className="mt-2">
                  <a href={editTender.fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-info">
                    <FaDownload className="me-1" /> Mevcut Dosyayı İndir
                  </a>
                </div>
              )}
              <Form.Text className="text-muted">
                Yeni bir dosya seçmezseniz mevcut dosya korunacaktır.
              </Form.Text>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              İptal
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? 'Güncelleniyor...' : 'Güncelle'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default TenderList;
